module.exports = __webpack_public_path__ + "img/partner-program.9df7be0c.svg";